import { styled } from '@linaria/react';

export const StyledFieldColor = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: var(--gap-m);
`;

export const ColorIcon = styled.div<{ color: string }>`
	width: 16px;
	border: 1px var(--color-grey-44-solid) solid;
	border-radius: 100%;
	aspect-ratio: 1;
	background-color: ${({ color }) => color};
`;
